import {AccountPaymentReceiptReportData} from "./account-payment-receipt-report.data";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class AccountPaymentReceiptReportModel extends ReportModel<AccountPaymentReceiptReportData> {
    constructor(injector: Injector) {
        super(injector, AccountPaymentReceiptReportData)
    }
}
